import { ScrollView, Text } from "react-native";
import ValidationCard from "./ValidationCard.component";
import styles from './EspaceValideur.styles';
import { ListeValidationDemandeProps } from "./EspaceValideur.types";

export default function ListeValidationDemande({ demandes, onReject, onValidate }: ListeValidationDemandeProps) {
    return(
        <>
            <Text style={styles.pageSubtitle}>Demandes d'absence</Text>
            <ScrollView contentContainerStyle={styles.validationCardContainer}>
                {demandes.map((demande) => (
                    <ValidationCard
                        key={demande.identifiant}
                        demande={demande}
                        onReject={onReject}
                        onValidate={onValidate}
                    />
                ))}
            </ScrollView>
        </>
    )
}
